module.exports = __webpack_public_path__ + "static/1984-fee2cde0ee6bb694cd818e955a025b47.jpg";